import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="block group fade-up"
      style={{ animationDelay: `${(index % 4) * 80}ms` }}
    >
      <div className="product-img-wrap aspect-[4/5] bg-[#F5F2EB] mb-5">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="product-img w-full h-full object-cover"
        />
      </div>
      <div className="flex items-start justify-between gap-4">
        <h3 className="font-serif text-xl tracking-tight leading-snug">
          {product.name}
        </h3>
        <div className="text-sm font-medium text-[#2C2421] whitespace-nowrap pt-1">
          {product.price_label}
        </div>
      </div>
      <p className="mt-2 text-sm text-[#6F4E37]/85 leading-relaxed line-clamp-2">
        {product.short_description}
      </p>
    </Link>
  );
}
